<template>
    <div>
        <el-dialog
            title="修改重要程度"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                    <el-form-item label="原重要程度" v-if="tableDataItem">
                        <span>{{ tableDataItem.importanceLevel | initDic(importanceLevelDic) }}</span>
                    </el-form-item>
                    <el-form-item prop="importanceLevel" label="变更后" label-width="100px">
                        <le-select-local-search large style="padding: 0;width:380px" v-model="form.importanceLevel" :options="importanceLevelDic" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {
                    importanceLevel: '',
                },
                rules: {
                    importanceLevel: [{required: true, message:'请选择重要程度', trigger: 'change'}]
                },
                importanceLevelDic: [],
            };
        },
        props: ['tableDataItem'],
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            }
        },
        created () {
            this.$getDic('importLevel','select').then(res=>{ this.importanceLevelDic = res; })
        },
        methods:{
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let reqData = {
                            ...this.form
                        }
                        this.$confirm('是否确认提交？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_=>{
                            this.$emit('handlerSuccess', reqData)
                            this.dialogVisible = false
                        }).catch(_=>{ })
                    }
                })
                
            },

        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>